import { useState } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';

interface AIRegenerateButtonProps {
  onRegenerate: (tone: string, length: string, currentContent: string) => Promise<string>;
  onAccept: (content: string) => void;
  currentContent: string;
}

export function AIRegenerateButton({ onRegenerate, onAccept, currentContent }: AIRegenerateButtonProps) {
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    setGenerating(true);

    try {
      const result = await onRegenerate('professional', 'medium', currentContent);
      onAccept(result);
    } catch (error) {
      console.error('Failed to generate:', error);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <button
      onClick={handleGenerate}
      disabled={generating}
      className="p-2 text-[#05E0D1] hover:bg-[#05E0D1]/10 rounded-lg transition-all hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed disabled:scale-100"
      title="AI Regenerate"
    >
      {generating ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <Sparkles className="w-5 h-5" />
      )}
    </button>
  );
}
